<template>
  <div class="difficulty-analysis">
    <div class="charts_el" ref="chartsEl"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "GjkcH5DifficultAnalysisPie",

  data() {
    return {
      chartData: [
        { name: "简单", value: 20 },
        { name: "困难", value: 12 },
        { name: "普通", value: 8 },
        { name: "特难", value: 2 }
      ]
    };
  },

  mounted() {
    // this.initCharts();
  },

  methods: {
    initCharts() {
      var chartDom = this.$refs.chartsEl;
      var myChart = echarts.init(chartDom);
      var option;
      const colorList = [
        "#47A2FF",
        "#53C8D1", 
        "#59CB74",
        "#FBD444",
        "#7F6AAD",
        "#585247",
      ];

      // 计算总题数
      const totalQuestions = this.chartData.reduce((sum, item) => sum + item.value, 0);

      option = {
        title: {
          text: "总题数",
          subtext: totalQuestions.toString(),
          textStyle: {
            fontSize: 16,
            color: "#999",
            lineHeight: 20,
          },
          subtextStyle: {
            fontSize: 28,
            color: "#333",
            fontWeight: "bold"
          },
          textAlign: "center",
          left: "48%",
          top: "22%", // 调整标题位置，使其在饼图中心
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          type: "plain",
          orient: "horizontal", // 水平排列
          left: "center",
          top: "65%", // 将图例放在底部
          itemWidth: 14,
          itemHeight: 14,
          itemGap: 20,
          pageButtonItemGap: 5,
          pageButtonPosition: "end",
          pageFormatter: "",
          pageIcons: {
            horizontal: ["M0,0L12,-10L12,10Z", "M0,0L-12,-10L-12,10Z"]
          },
          textStyle: {
            color: "#333",
            fontSize: 12
          },
          formatter: (name) => {
            const item = this.chartData.find(d => d.name === name);
            return `${name}  ${item ? item.value : 0}`;
          },
          data: this.chartData.map(item => item.name)
        },
        color: colorList,
        series: [
          {
            name: "难度分析",
            type: "pie",
            radius: ["35%", "60%"], // 环形图
            center: ["50%", "30%"], // 将饼图向上移动
            avoidLabelOverlap: false,
            label: {
              show: false
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "14",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              borderWidth: 2,
              borderColor: "#fff"
            },
            data: this.chartData
          }
        ]
      };

      // 添加响应式处理
      window.addEventListener("resize", function() {
        myChart.resize();
      });

      option && myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
.difficulty-analysis {
  width: 100%;
  height: 400px;
  position: relative;
  
  .charts_el {
    width: 100%;
    height: 100%;
    position: relative;
  }
}
</style>